// AttendanceCalendar.jsx
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import { useState } from 'react';

export default function AttendanceCalendar() {
  const [events, setEvents] = useState([
    // Example event
    {
      title: 'Check In',
      start: new Date().toISOString().slice(0, 10),
      className: 'bg-emerald-500/90 border-0 text-white',
    },
  ]);

  return (
    <div className="min-h-[500px]">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrap5Plugin]}
        initialView="dayGridMonth"
        themeSystem="bootstrap5"
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        dayHeaderClassNames={() => 'bg-gray-50/80 uppercase tracking-wider'}
        dayCellClassNames={() => 'hover:bg-indigo-50/50 transition-colors'}
        eventClassNames={() => 'bg-emerald-500/90 border-0 text-white'}
        nowIndicator={true}
        nowIndicatorClassNames="border-t-2 border-red-500"
        events={events}
        eventContent={eventInfo => (
          <div className="flex items-center p-1">
            <div className="w-2 h-2 rounded-full bg-white mr-2"></div>
            <span className="text-xs font-medium truncate">{eventInfo.timeText}</span>
          </div>
        )}
        dayCellContent={cellInfo => {
          const todayClass = cellInfo.isToday
            ? 'bg-gradient-to-br from-indigo-500/10 to-purple-500/10'
            : '';
          return (
            <div className={`flex justify-center items-center h-8 w-8 rounded-full ${todayClass}`}>
              {cellInfo.dayNumberText}
            </div>
          );
        }}
        height={500}
      />
    </div>
  );
}
